import React, {useEffect, useState, useRef} from "react";
import { Button } from 'primereact/button';
import {productFilterAPI, productsAPI} from "../../api/api";
import useDiscount from "../Hooks/useDiscount";
import useToken from "../Hooks/useToken";
import styles from './Catalog.module.css'
import {InputText} from 'primereact/inputtext';
import _ from "lodash";
import {Toast} from "primereact/toast";
import {Filters} from "../Filters/Filters";
import "./Catalog.css"
import { Sidebar } from 'primereact/sidebar';
import {SelectedFilters} from "../Filters/SelectedFilters/SelectedFilters";
import { DiscountProgressBar } from "../DiscountProgressBar/DiscountProgressBar";
import { SpinnerUA } from "../../common/Spinners/SpinerUA/SpinnerUA";
import {CatalogProductNew} from "../Product/CatalogProductNew/CatalogProductNew";
import { ScrollPanel } from 'primereact/scrollpanel';
import {useWindowDimensions} from '../../Context/WindowDimensionsContext'

import {MarketingStockCatalogComponent} from '../MarketingStock/MarketingStockCatalogComponent/MarketingStockCatalogComponent'
import {useCartContext} from "../../Context/CartContext";

export const Catalog = ({clientId}) => {

    const initCheckedFiltersObject = {
        EngineTypes: [],
        OilViscosities: [],
        ProductPackages: [],
        OilTypes: [],
        Specifications: [],
        Admittances: [],
        EquipmentСategories: [],
        ProductСategories: []
    }

    const toast = useRef(null);
    const discountBarToast = useRef(null);

    const {viewPortWidth,viewPortHeight} = useWindowDimensions();

    //discount Hook
    const {discountModel, getDiscountModel, saveDiscountModel} = useDiscount();
    //spinner in modal
    const [isLoading, setIsLoading] = useState(true);

    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [marketingStockList, setMarketingStockList] = useState([]);
    const [allProductPriceAmount, setAllProductPriceAmount] = useState(0);
    const [searchText, setSearchText] = useState('');

    const [filters, setFilters] = useState({});
    const [baseFilterList, setBaseFilterList] = useState({})
    const [checkedFiltersObject, setCheckedFiltersObject] = useState(initCheckedFiltersObject)

    const [visibleFilterSidebar, setVisibleFilterSidebar] = useState(false);

    const {token} = useToken()

    const {cart, getCart} = useCartContext();

    const [items, setItems] = useState([]);

    useEffect(() => {
        setItems(filteredProducts)
    },[filteredProducts])

    useEffect(() => {
        if (clientId !== "") {
            getProducts().then();
        }
    }, [clientId]);

    useEffect(() =>{
        filterProductsBySearch();
    },[searchText])

    useEffect(() => {
        const productListWithCountInCart = getListProductCountInCart();
        setFilteredProducts(productListWithCountInCart);

    }, [cart])

    useEffect(() => {
        console.log(checkedFiltersObject);

        const isEmpty = isCheckedFiltersObjectEmpty(checkedFiltersObject)

        //проверяем, что список выбранных фильров не пустой, чтобы не слать на сервак лишние запросы
        if(!isEmpty){
            let body = {
                SelectedProductFilters: checkedFiltersObject,
                BaseProductFilters: filters
            }
            getProductsWithFilter(body).then();
        }
        else {
            getProducts().then()
        }

        setSearchText("");

    }, [checkedFiltersObject])

    const setLoadingFalse = () => {
        setIsLoading(false);
    }

    const isCheckedFiltersObjectEmpty = (object) => {
        let isEmpty = true;
        _.forIn(object, function(value, key) {
            if(value.length > 0){
                isEmpty = false;
                return false;
            }
        });

        return isEmpty;
    }

    const getListProductCountInCart = (productList = null) => {
        if(cart && filteredProducts.length > 0 && productList === null){
            const actualCart = JSON.parse(getCart());
            const prodsInCart = actualCart.BaseOrder;

            const filteredProductsWithCountInCart = _.cloneDeep(filteredProducts);

            filteredProductsWithCountInCart.forEach((product, index) => {
                const findProduct = prodsInCart.find(item => item.id === product.Id)

                if(findProduct){
                    product.countInCart = findProduct.count;
                    console.log(product.ProductName, product.countInCart)
                }
                else{
                    product.countInCart = 0;
                }
            })

            return filteredProductsWithCountInCart;
        }
        else if(cart && productList !== null && productList.length > 0){
            const actualCart = JSON.parse(getCart());
            const prodsInCart = actualCart.BaseOrder;

            const filteredProductsWithCountInCart = _.cloneDeep(productList);

            filteredProductsWithCountInCart.forEach((product, index) => {
                const findProduct = prodsInCart.find(item => item.id === product.Id)

                if(findProduct){
                    product.countInCart = findProduct.count;
                    console.log(product.ProductName, product.countInCart)
                }
                else{
                    product.countInCart = 0;
                }
            })

            return filteredProductsWithCountInCart;
        }
        return [];
    }

    const onClickClearSearchTextButton = () =>{
        setSearchText("");
    }

    const filterProductsBySearch = () => {
        debugger
        if (searchText === '') {
            const productListWithCountInCart = getListProductCountInCart(products);
            setFilteredProducts(productListWithCountInCart);
            return;
        }

        const lowerSearch = searchText.toLowerCase();

        const filtered = products.filter(prod => {
            const matchByName = prod.ProductName?.toLowerCase().includes(lowerSearch);
            const matchByNumber = prod.ProductNumber?.toLowerCase().includes(lowerSearch);
            const matchByArticle = Array.isArray(prod.ArticleList)
            && prod.ArticleList.some(article => article.toLowerCase().includes(lowerSearch));

            return matchByName || matchByNumber || matchByArticle;
        });

        const productListWithCountInCart = getListProductCountInCart(filtered);
        setFilteredProducts(productListWithCountInCart);
    };

    const getProductsWithFilter =  async(body) =>{
        setIsLoading(true);
        body.BaseProductFilters = baseFilterList;

        const {data} = await productFilterAPI.getProductsWithFilters(body)
        let resp = JSON.parse(data);

        if(resp.isSucccess){
            setFilters(resp.data.ProductFilterList)

            const Products = resp.data.Products;
            const productListWithCountInCart = getListProductCountInCart(Products);
            setProducts(Products);
            setFilteredProducts(productListWithCountInCart)
        }
        setLoadingFalse();
        console.log(resp)
    }

    const getProducts = async () => {
        setIsLoading(true);
        console.log("start axios CATALOG")
        const {data} = await productsAPI.getClientsProducts(clientId, token);
        const result = JSON.parse(data);

        console.log(result.ProductFilterList);
        setFilters(result.ProductFilterList)

        //базовый список, который летит на бэк, чтобы не изменялись основные фильта
        setBaseFilterList(result.ProductFilterList)

        const Products = result.Products;
        setProducts(Products);

        //на страничке отображаем фильтрованные продукты, поэтому сразу в фильтрованные и заносим список с бэка.
        const productListWithCountInCart = getListProductCountInCart(Products);
        setFilteredProducts(productListWithCountInCart)

        //скидки в storage
        setDiscount(result.DiscountModel);

        //stocks
       if(result.StockList.length > 0){
            setMarketingStockList(result.StockList)

        }
        setLoadingFalse();
    };


    const setDiscount = (model) => {
        if(model){
            saveDiscountModel(model)
        }
    }

    const renderProduct = (p) => {
        return (
            <CatalogProductNew
                id={p.Id}
                name={p.ProductName}
                number={p.ProductNumber}
                articleList={p.ArticleList}
                recommendPrice={p.ReccomendPrice}
                priceList={p.ProductPriceList}
                count={p.Count}
                key={p.Id}
                balance ={p.TotalBalance}
                deliveryDate={p.DeliveryDate}
                isDiscount={p.IsDiscount}
                smallImageUrls={p.SmallImageUrl}
                allProductPriceAmount={allProductPriceAmount}
                setAllProductPriceAmount={setAllProductPriceAmount}
                countInCart={p.countInCart}
                toast={toast}
            />
        );
    };

    if (products.length === 0) {
        
    }

    const filterSideBarHeader = (
        <div className='flex align-items-center gap-2'>
            <Button style={{borderRadius:'5px'}} label='Скасувати фільтри' severity="secondary" onClick={() => {
                setCheckedFiltersObject(initCheckedFiltersObject);
                setVisibleFilterSidebar(false)
            } } />
            <Button style={{borderRadius:'5px'}} label='Прийняти'  onClick={() => setVisibleFilterSidebar(false)} />
        </div>
    )

    const customSideBarIcons = (<span></span>);


    return (

        <div className="catalog">
            {viewPortWidth <= 1100 ? <Button onClick={() => setVisibleFilterSidebar(true)}  icon="pi pi-filter" severity="info" className={styles.filterButton} >Фільтр</Button> : null}
            {isLoading ?
            <div className={styles.spinner}>
                         <div >
                             <SpinnerUA />
                        </div>
            </div>: null}
            
            {/* <div className={styles.filterBlock}>
                        <span className="p-input-icon-left" style={{display:'flex', alignItems:'center'}}>
                              <i className="pi"/>
                              <InputText className={`${styles.input} ${viewPortWidth <= 1100 ? 'p-inputtext-sm' : 'p-inputtext-lg' }`} value={searchText} onChange={(e) => setSearchText(e.target.value)}
                                         placeholder="Введіть назву продукту"/>
                                         <Button icon="pi pi-times" onClick={onClickClearSearchTextButton} rounded text severity="danger" aria-label="Очистити" />

                        </span>

                        <SelectedFilters checkedFiltersObject={checkedFiltersObject} setCheckedFiltersObject={setCheckedFiltersObject}  />

            </div> */}

            <div className={styles.catalogWrapper}>


                {viewPortWidth > 1100 ? <div className={styles.filtersWrapper}>
                        <span className="p-input-icon-left" style={{position:"relative", display:'flex', alignItems:'center', padding:'2px 5px 5px 0px'}}>
                              {/* <i className="pi"/> */}
                              <InputText className={`${styles.input} ${viewPortWidth <= 1100 ? 'p-inputtext-sm' : 'p-inputtext-lg' }`} value={searchText} onChange={(e) => setSearchText(e.target.value)}
                                         placeholder="Введіть назву продукту або ТОВ"/>
                                         <Button icon="pi pi-times" style={{position:"absolute", right: '10px'}} onClick={onClickClearSearchTextButton} rounded text severity="danger" aria-label="Очистити" />

                        </span>

                    <div style={{paddingTop:'5px', paddingBottom:'5px'}}>
                        <SelectedFilters checkedFiltersObject={checkedFiltersObject} setCheckedFiltersObject={setCheckedFiltersObject}  />
                    </div>
                    <Filters
                        filters={filters}
                        getProductsWithFilter = {getProductsWithFilter}
                        checkedFiltersObject={checkedFiltersObject}
                        setCheckedFiltersObject={setCheckedFiltersObject}
                    />
                </div> : 
                    <Sidebar visible={visibleFilterSidebar} onHide={() => setVisibleFilterSidebar(false)} icons={customSideBarIcons} header={filterSideBarHeader} className="w-full md:w-30rem lg:w-40rem"> <Filters
                        filters={filters}
                        getProductsWithFilter = {getProductsWithFilter}
                        checkedFiltersObject={checkedFiltersObject}
                        setCheckedFiltersObject={setCheckedFiltersObject}
                    /> </Sidebar>}


                {!isLoading ? <div className={styles.productList}>
                    <Toast ref={toast}></Toast>
                    {viewPortWidth <= 1100 ? 
                            <div >
                                <span className={styles.searchText}>
                                    <i className="pi"/>
                                    <InputText className={`${styles.input} ${viewPortWidth <= 1100 ? 'p-inputtext-sm' : 'p-inputtext-lg' }`} value={searchText} onChange={(e) => setSearchText(e.target.value)}
                                                placeholder="Введіть назву продукту або ТОВ"/>
                                                <Button icon="pi pi-times" style={{position:"absolute", right: viewPortWidth > 700 ? '20px' : '10px' }} onClick={onClickClearSearchTextButton} rounded text severity="danger" aria-label="Очистити" />

                                </span>
                                <div className={styles.selectedFiltersWrapper} >
                                    <SelectedFilters checkedFiltersObject={checkedFiltersObject} setCheckedFiltersObject={setCheckedFiltersObject}  />
                                </div>
                            </div> 
                        : null}
                    <div>
                        <DiscountProgressBar/>
                    </div>

                    <ScrollPanel style={{ width: '100%', height: '100%' }}>
                        
                        <MarketingStockCatalogComponent stockList={marketingStockList} />
                        <div className={styles.catalogProductGrid} >
                            {filteredProducts.map((product) => renderProduct(product))}
                        </div>
                    </ScrollPanel>

                </div> : null}
            </div>
        </div>
    )
}